<router-outlet></router-outlet>
<div class="startup-loader" *ngIf="(loader.loading$ | async)?.global" role="status" aria-label="Loading">
  <app-full-loading></app-full-loading>
</div>
